import React, { Component } from 'react';
import { Link } from 'react-router';

import './style.css';
import Button from './../button/Button';


export default class Error404 extends Component {

  render() {
    return (
      <div className='error'>
        <div className='error__title'>
          <div className='error__title-text error__title-text_left'>4</div>
          <img src='/static/images/head-boy.png' className='error__boy' alt='Ошибка' />
          <div className='error__title-text error__title-text_right'>4</div>
        </div>
        <div className='error__text'>Упс... что-то пошло не так!</div>
        <Link to='/'><Button styleClasses={['error__button']} >На главную</Button></Link>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/blocks/errors/Error404.js